import {Box, IconButton} from "@mui/material"
import {PhotoProvider, PhotoView} from 'react-photo-view';
import {useSearchParams} from "react-router-dom";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {useQueryFile} from "@/service/file.s";
import {checkQueryKey} from "@/helper/method";
import {isEmpty} from "lodash";
import {useMemo} from "react";
import {mediaType} from "@/helper/constant";
import 'react-photo-view/dist/react-photo-view.css';
import Stack from "@mui/material/Stack";

import {RotateRightOutlined, RotateLeftOutlined, AddCircleOutlineOutlined, RemoveCircleOutlineOutlined} from '@mui/icons-material';

export const FilePreview = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const {data: fileData, isLoading} = useQueryFile({id: parseInt(id!)}, checkQueryKey(parseInt(id!)))
    const file = fileData?.data

    const images: string[] = useMemo(() => {
        if (file) {
            let images: string[] = []
            if (!isEmpty(file?.images)) {
                images = file?.images?.split(",") || ''
            } else if ((mediaType["image"].indexOf(file?.type?.toLowerCase()) > -1) && !isEmpty(file?.url)) {
                images.push(file?.url)
            }
            return images
        }
        return []
    }, [file])

    // linear-gradient(#FFF 0%, #ebf5ff 100%)
    return <Box sx={{
        background: '#f5f6fa',
        minHeight: '100vh',
        height: "calc((1 - var(--template-frame-height, 0)) * 100%)",
    }}> <ResultWrapper isLoading={isLoading} isEmpty={isEmpty(file)}>
        <PhotoProvider toolbarRender={({rotate, onRotate, scale, onScale}) => {
            return <Stack alignContent={'center'} spacing={1} direction={'row'}>
                <IconButton onClick={() => onRotate(rotate - 90)}>
                    <RotateLeftOutlined sx={{color: '#fff'}}/>
                </IconButton>
                <IconButton onClick={() => onRotate(rotate + 90)}>
                    <RotateRightOutlined sx={{color: '#fff'}}/>
                </IconButton>

                <IconButton onClick={() => onScale(scale + 0.6)}>
                    <AddCircleOutlineOutlined sx={{color: '#fff'}}/>
                </IconButton>
                <IconButton onClick={() => onScale(scale - 0.6)}>
                    <RemoveCircleOutlineOutlined sx={{color: '#fff'}}/>
                </IconButton>
            </Stack>
        }}>
            <Stack alignItems={'center'} py={2} spacing={2} width={'100%'} direction={'column'}>
                {images.map((item, index) => (
                    <PhotoView key={index} src={item}>
                        <Box height={480} sx={{objectFit: 'fill', border: '1px dashed rgb(0,0,0,0.12)'}} width={'38%'} component={'img'} src={item} alt={file?.name}/>
                    </PhotoView>
                ))}
            </Stack>
        </PhotoProvider>

    </ResultWrapper>
    </Box>
}